<div class="wrapper">
  <div class="mb20 fs18">Microsoft has discontinued Internet Explorer.</div>
  <div>Please download Microsoft Edge, Google Chrome or Mozilla Firefox to log into RxPhoto</div>
</div>
